var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 24,
    height: 24,
    transform: "translate(4131 3258)",
    fill: "#2dfd95",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    "data-name": "Mask Group 26",
    transform: "translate(-4131 -3258)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "link-horizontal-regular",
    d: "M11.4,2.4a5.395,5.395,0,0,1,.36,10.778l-.3.019a.9.9,0,1,1-.12-1.792l.3-.023A3.595,3.595,0,0,0,11.4,4.2H5.4a3.595,3.595,0,0,0-.24,7.181l.3.023A.9.9,0,0,1,5.34,13.2l-.3-.019A5.395,5.395,0,0,1,5.4,2.4ZM12.6,16.8a5.4,5.4,0,0,1-.364-10.781L12.5,6a.9.9,0,1,1,.12,1.792l-.266.019A3.6,3.6,0,0,0,12.6,15H18.6a3.595,3.595,0,0,0,.24-7.181l-.3-.023A.9.9,0,1,1,18.66,6l.3.019A5.395,5.395,0,0,1,18.6,16.8Z",
    transform: "translate(4131 3260.4)",
    fill: "#2dfd95"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaired);
export default __webpack_public_path__ + "static/media/paired.526baf3f0a96c3ed597da71dd456cfdf.svg";
export { ForwardRef as ReactComponent };